import { ref as dbRef, get, set } from "firebase/database";
import { db } from "@/firebaseConfig";

export default {
  namespaced: true,
  state() {
    return {
      users: [],
      loading: false,
    };
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    UPDATE_USER_ROLE(state, { uid, role }) {
      const user = state.users.find((u) => u.uid === uid);
      if (user) {
        user.role = role;
      }
    },
  },
  actions: {
    async fetchUsers({ commit, rootGetters }) {
      // Security check in UI
      const currentUserRole = rootGetters.getRole;
      if (currentUserRole !== 'admin') {
        console.error("Only admins can fetch all users.");
        return;
      }

      commit("SET_LOADING", true);
      try {
        const usersRef = dbRef(db, "users");
        const snapshot = await get(usersRef);
        const usersData = snapshot.val();

        if (usersData) {
          const usersList = Object.keys(usersData).map((uid) => ({
            uid,
            ...usersData[uid],
          }));
          commit("SET_USERS", usersList);
        } else {
          commit("SET_USERS", []);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async updateUserRole({ commit }, { uid, currentData, newRole }) {
      try {
        const userRef = dbRef(db, `users/${uid}`);
        // Keep existing data, just update the role
        const updatedData = { ...currentData, role: newRole };
        await set(userRef, updatedData);
        commit("UPDATE_USER_ROLE", { uid, role: newRole });
      } catch (error) {
        console.error("Error updating user role:", error);
      }
    }
  },
  getters: {
    getUsers(state) {
      return state.users;
    },
    isLoading(state) {
      return state.loading;
    },
  },
};
